<div class="wallet-container mat-typography">

  <div class="back-and-payment-method">
    <div class="selected-payment-method flex justify-center sm:justify-center items-center round-border-normal mt-4 sm:mr-0 sm:mt-8">
      <span class="wpx-200 hpx-125 sm:wpx-250 sm:hpx-150 background-cover rounded-md bg-cover flex justify-center items-center">
        <img class="w-full" [src]="paymentMethodImg">
      </span>
    </div>
  </div>

  <div class="flex flex-wrap" [ngClass]="loading ? 'sm:mb-12 mt-16 justify-center p-4' : ''">
    <div class="container flex justify-center m-0 flex-wrap bg-gray-300 items-center w-10/12 min-h-100" style="border-radius: 12px;" *ngIf="loading">
      <mat-spinner
        class="loading-spinner"
        [color]="color"
        [diameter]="diameter"
      >
      </mat-spinner>
    </div>
    <router-outlet></router-outlet>
<!--    <app-mobicred-login (notify)="getTimeRemaining($event)" *ngIf="!otpState"></app-mobicred-login>-->
<!--    <app-mobicred-otp  *ngIf="otpState"></app-mobicred-otp>-->
<!--    [timeRemaining]="timeRemaining"-->
  </div>

  <div class="bottom-container w-full flex flex-row items-end pl-0 pr-0 sm:pl-2 sm:pr-2 pb-0 justify-between absolute bottom-0 mat-typography">
    <p class="text-md sm:text-lg ml-2 text-gray-800 mb-2">This is a secure transaction</p>
    <img *ngIf="!hidePgLogo" class="sm:h-14 h-12 mr-2 mb-0 sm:mr-2 sm:mb-1" src="assets/icons/Icons/Group.png">
  </div>

</div>
